
const getCustomInputTagValues = (inputsData, tagDisplayValues) => {
    for (const tagKey in tagDisplayValues) {
        if (inputsData[tagKey]) {
            for (const tagValue in tagDisplayValues[tagKey]) {
                if (inputsData[tagValue]) {
                    inputsData[tagKey] = tagDisplayValues[tagKey][tagValue]
                    break;
                }
            }
        }
    }
    return inputsData
}

const getInputTagValues = (userResponse, quiz) => {
    let inputsData = {};
    let tagDisplayValues = quiz?.tagDisplayValues
    userResponse.forEach((response) => {
        for (let answer of response.answerResponse) {
            answer.tag.split(",").forEach((tag) => {
                if (response.questionType == "input") {
                    inputsData[tag] = answer.inputValue
                } else if (response.questionType == "single" || response.questionType == "multi") {
                    inputsData[tag] = answer.answerText
                }
            })
        }
    })
    if (tagDisplayValues) {
        return getCustomInputTagValues(inputsData, tagDisplayValues)
    }
    return inputsData;
}

export default getInputTagValues;